// Comprehensive resume data for AI Chat - Updated with current information
export const resumeData = `
### Dhrumit Patel – AI Engineer & Full Stack Developer

**Contact Information:**
- 📍 Toronto, ON, Canada
- 📧 Email: dhrumitpatel.ai@gmail.com
- 🔗 LinkedIn: [linkedin.com/in/dhrumitpatelds](https://linkedin.com/in/dhrumitpatelds)
- 💻 Portfolio: [dhrumitpatel.dev](https://dhrumitpatel.com)
- 🐙 GitHub: [github.com/Dhrumit1314](https://github.com/Dhrumit1314)
- 🤗 Hugging Face: [huggingface.co/Dhrumit1314](https://huggingface.co/Dhrumit1314)

---

**🎯 Professional Summary:**
Experienced and results-driven AI Engineer and Full Stack Developer with specialized expertise in Machine Learning, NLP, Computer Vision, and Financial Crime Model Validation. Currently working at Royal Bank of Canada as Manager of Global FC/AML Model Validation, where I apply advanced machine learning techniques to validate financial crime detection models. Skilled in Python, SQL, Java, and JavaScript with extensive experience in full-stack development, cloud computing, and DevOps. Proven ability in building AI-driven applications, collaborating in agile teams, and ensuring regulatory compliance. Proficient with Docker, AWS, Azure, and modern data tools.

---

**🧠 Skills:**

- **Languages:** Python, SQL, Java, JavaScript
- **Machine Learning & NLP:** Scikit-learn, Deep Learning, NLP Techniques, LLMs
- **Information Retrieval & Recommenders:** Search algorithms, classification, evaluation metrics
- **Frontend:** React.js, HTML, CSS
- **Backend:** Node.js, Express.js
- **Databases:** MySQL, PostgreSQL, SQL Server
- **Cloud & DevOps:** AWS, Microsoft Azure, Docker, CI/CD Pipelines
- **Data Analysis & Visualization:** Pandas, NumPy, Matplotlib, Seaborn, Plotly, Power BI
- **Tools:** Git, Docker, WebSockets
- **Soft Skills:** Strong communication, collaborative teamwork, English proficiency

---

**🎓 Education:**

**Advanced Diploma in Software Engineering Technology – Artificial Intelligence**  
*Centennial College, Toronto, ON*  
*April 2024*  
**Relevant Coursework:** Full Stack Development, Machine/Deep Learning, Data Analysis, Cloud Computing

---

**💼 Experience:**

**Manager, Global FC/AML Model Validation**  
*Royal Bank of Canada, Toronto, ON*  
*Oct 2024 – Present*
- Applied machine learning and statistical techniques to support the validation of Financial Crime models, including transaction monitoring, sanctions screening, and customer risk scoring models.
- Assessed model performance and conceptual soundness through quantitative testing, data integrity checks, and implementation reviews, aligning with regulatory standards (OSFI E-23, SR 11-7).
- Developed and executed validation frameworks using Python and SQL, incorporating sensitivity testing, benchmarking, and scenario analysis.
- Collaborated with cross-functional teams including Compliance, Data Science, and Technology to review model assumptions, logic, thresholds, and production implementation.
- Authored clear and detailed validation reports summarizing findings, limitations, and remediation actions, and communicated results to Risk Committees and senior stakeholders.
- Ensured governance compliance through robust documentation and supported regulatory inquiries from FINTRAC and OSFI.

**Full Stack Developer (Intern)**  
*Centennial College – ARIES, Toronto, ON*  
*Sept 2023 – Dec 2023*
- Developed backend services for vehicle management with secure CRUD operations.
- Strengthened system security using multi-layer authentication techniques.
- Integrated WebSockets for real-time communication, boosting responsiveness by 30%.
- Utilized Docker to ensure scalable and environment-consistent deployments.
- Contributed to full-stack features using Express.js, supporting high-performance web apps.

---

**🛠️ Key Projects:**

**1. Face Recognition Sign-In/Sign-Out Application**  
- **Tech Stack:** Python, AWS (Lambda, S3, DynamoDB, Rekognition), OpenCV, Tkinter  
- **Description:** Built a secure and automated attendance system using face recognition technology. Designed GUI in Tkinter and used AWS cloud services for backend processes.  
- **Features:** Real-time face detection, secure authentication, automated attendance tracking
- **GitHub:** [View Project](https://github.com/Dhrumit1314/face-recognition-attendance)

**2. Facial Emotion, Age & Gender Detection**  
- **Tech Stack:** Python, OpenCV, Deep Learning, TensorFlow  
- **Description:** Developed an advanced facial analysis tool achieving:
  - 95% accuracy in emotion detection  
  - 90% in age prediction  
  - 98% in gender recognition  
- **Features:** Real-time analysis, multiple emotion categories, age range prediction
- **GitHub:** [View Project](https://github.com/Dhrumit1314/facial-analysis)

**3. AI-Powered Portfolio Assistant**  
- **Tech Stack:** React.js, Google Gemini API, Node.js, SCSS  
- **Description:** Intelligent chatbot for portfolio websites with real-time data integration
- **Features:** Resume-based responses, GitHub/Hugging Face integration, real-time profile data
- **Live Demo:** [Current Portfolio](https://dhrumitpatel.dev)

**4. Financial Crime Model Validation Framework**  
- **Tech Stack:** Python, SQL, Statistical Analysis, Regulatory Compliance  
- **Description:** Developed comprehensive validation frameworks for FC/AML models at RBC
- **Features:** Model performance assessment, regulatory compliance, risk scoring validation

**4. Model white paper summary - RAG**  
- **Tech Stack:** Python, Langchain, Cohere API, Compass RAG, Command A Model
- **Description:** AI-powered application that uses Cohere's Compass RAG for advanced context understanding and Command A model to generate comprehensive summaries and extract key information from uploaded model white papers.
- **Features:** Upload model white papers, AI-powered processing using RAG, Automatic key information extraction


---

**🏆 Achievements & Certifications:**
- Successfully validated multiple FC/AML models at RBC, ensuring regulatory compliance
- Achieved 95%+ accuracy in facial recognition and emotion detection projects
- Contributed to open-source projects on GitHub and Hugging Face
- Completed Advanced Diploma in Software Engineering Technology – AI from Centennial College

**📌 Additional Information:**
- **Languages:** English (Fluent), Gujarati (Native)
- **Interests:** Machine Learning, Computer Vision, Financial Technology, Open Source
- **Availability:** Open to interesting opportunities and collaborations
- **More Projects:** Visit my [GitHub](https://github.com/Dhrumit1314) and [Hugging Face](https://huggingface.co/Dhrumit1314) profiles for additional projects and contributions
`;

// Social media profiles configuration
export const socialProfiles = {
  linkedin: {
    username: "dhrumitpatelds",
    url: "https://linkedin.com/in/dhrumitpatelds",
  },
  github: {
    username: "Dhrumit1314",
    url: "https://github.com/Dhrumit1314",
  },
  huggingface: {
    username: "Dhrumit1314",
    url: "https://huggingface.co/Dhrumit1314",
  },
};

// API endpoints for fetching profile data
export const apiEndpoints = {
  github: "https://api.github.com/users/Dhrumit1314",
  githubRepos: "https://api.github.com/users/Dhrumit1314/repos",
  huggingface: "https://huggingface.co/api/users/Dhrumit1314",
};
